<template>
<div>
    <navi selectedid="tlCompany"></navi>
    <subNavi selectedid="tlCulture" lastrouter="/company/aboutus" nextrouter="/company/rnd"></subNavi>
    
    <div id="Contents">
        <logo selectedid="tlCompany"></logo>

        <spNavi selectedid="tlCulture"></spNavi>

        <div id="Main">
            <culture_-content></culture_-content>
            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>

import Navi from "components/common/navi"
import SubNavi from "components/company/subnavi"
import Logo from "components/common/logo"
import SpNavi from "components/company/spnavi"
import Share from "components/common/share"
import WebFooter from "components/common/footer"
import Culture_Content from "components/company/culture_content"
export default {
  name: "Culture",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter,
    Culture_Content
  },
  data() {
    return {
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/company/culture.vue